import loadSagas from "./load";
import setSagas from "./set";

export const preferenceSagas = [
	...loadSagas,
	...setSagas
];

export default preferenceSagas;
